import * as React from 'react';

const Next = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.80019 7.80005L15.8891 13L7.80019 18.2V7.80005ZM15.8891 13V7.80005H18.2002V18.2H15.8891V13Z"
      fill="#63606E"
    />
  </svg>
);
export default Next;
